"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyStatHandler = exports.createStatHandler = exports.flushBatch = exports.flushBatches = exports.clearBatches = exports.page = exports.trackBatch = exports.track = exports.identify = void 0;
const WebStatUtils_1 = require("./WebStatUtils");
const Stat = __importStar(require("./Stat"));
const USER_ID_COOKIE_NAME = 'ajs_user_id';
const ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
const STATE = {
    handlers: [],
    workerCreationIsInProgress: false,
    worker: undefined,
    workerDiedTimes: 0,
};
function identify(statHandler, apiKey, user) {
    Stat.identify(statHandler, apiKey, user);
}
exports.identify = identify;
function track(statHandler, apiKey, event, properties, flags) {
    Stat.track(statHandler, apiKey, event, properties, flags);
}
exports.track = track;
function trackBatch(statHandler, apiKey, events, flags) {
    Stat.trackBatch(statHandler, apiKey, events, flags);
}
exports.trackBatch = trackBatch;
function page(statHandler, apiKey, properties, flags) {
    Stat.page(statHandler, apiKey, enrichWithUTMQueryParameters(properties), flags);
}
exports.page = page;
function enrichWithUTMQueryParameters(properties) {
    const enrichedProperties = properties || {};
    const queryParams = new URLSearchParams((0, WebStatUtils_1.getQueryParameters)());
    enrichedProperties.utm_campaign = getQueryParam(queryParams, 'utm_campaign');
    enrichedProperties.utm_content = getQueryParam(queryParams, 'utm_content');
    enrichedProperties.utm_custom = getQueryParam(queryParams, 'utm_custom');
    enrichedProperties.utm_medium = getQueryParam(queryParams, 'utm_medium');
    enrichedProperties.utm_source = getQueryParam(queryParams, 'utm_source');
    enrichedProperties.utm_term = getQueryParam(queryParams, 'utm_term');
    return enrichedProperties;
}
function getQueryParam(queryParams, queryParamName) {
    return queryParams.get(queryParamName)?.trim() || undefined;
}
function clearBatches(statHandler) {
    Stat.clearBatches(statHandler);
}
exports.clearBatches = clearBatches;
function flushBatches(statHandler, isPageHidden = false) {
    Stat.flushBatches(statHandler, isPageHidden);
}
exports.flushBatches = flushBatches;
function flushBatch(statHandler, apiKey) {
    Stat.flushBatch(statHandler, apiKey);
}
exports.flushBatch = flushBatch;
function createStatHandler(options) {
    const statHandler = Stat.createStatHandler({
        apiHost: options.apiHost,
        library: options.library,
        version: options.version,
        batches: options.batches,
        app: {
            name: options.app?.name,
            version: options.app?.version,
            getStoredUserIds: getStoredUserIds,
            storeUserIds: storeUserIds,
            addCommonStatParams(params) {
                return options.addCommonStatParams(params);
            },
            getStatContextPage: getStatContextPage,
            getUserAgent: getUserAgent,
            getSessionId: getSessionId,
            sendError: options.sendError,
        },
    });
    const allowWorker = !!options.worker;
    if (allowWorker && window.Worker) {
        tryCreateStatsWorker(STATE, options);
    }
    if (options.batches?.flushInterval) {
        statHandler.flushBatchesIntervalId = window.setInterval(() => {
            flushBatches(statHandler);
        }, options.batches.flushInterval);
    }
    STATE.handlers.push(statHandler);
    return statHandler;
}
exports.createStatHandler = createStatHandler;
function destroyStatHandler(statHandler) {
    clearInterval(statHandler.flushBatchesIntervalId);
    statHandler.flushBatchesIntervalId = undefined;
}
exports.destroyStatHandler = destroyStatHandler;
function tryCreateStatsWorker(state, options) {
    if (!state.worker && !state.workerCreationIsInProgress && options.worker) {
        state.workerCreationIsInProgress = true;
        if (state.workerDiedTimes > 5) {
            options.sendError('Stats worker dies too often', { count: state.workerDiedTimes });
            if (state.workerDiedTimes > 10) {
                return;
            }
        }
        let workerUrl = options.worker.url;
        const weAreOnCDN = options.weAreOnCDN ? options.weAreOnCDN() : false;
        if (weAreOnCDN) {
            const workerBlob = new Blob(['importScripts(' + JSON.stringify(workerUrl) + ')'], {
                type: 'application/javascript',
            });
            workerUrl = window.URL.createObjectURL(workerBlob);
        }
        const cleanUpAndTryToRestartWebWorker = (message, error) => {
            state.workerDiedTimes++;
            if (message) {
                error = error || 'Unknown';
                const extra = typeof error === 'string' ? error : getMessageFromWorkerError(error);
                const customError = new Error(message);
                options.sendError(customError, extra);
            }
            if (weAreOnCDN) {
                window.URL.revokeObjectURL(workerUrl);
            }
            tryCreateStatsWorker(state, options);
        };
        const createWorkerPromise = () => new Promise((resolve, reject) => {
            const worker = new Worker(workerUrl, { name: 'StatsWorker' });
            const timeoutId = setTimeout(() => reject(new Error('timeout')), 10000);
            const onInitError = (error) => {
                worker.terminate();
                reject(error);
            };
            const onReady = (event) => {
                if (event.data === 'ready') {
                    clearTimeout(timeoutId);
                    worker.removeEventListener('message', onReady);
                    worker.removeEventListener('error', onInitError);
                    worker.addEventListener('error', error => {
                        worker.terminate();
                        state.handlers.forEach(handler => {
                            handler.worker = undefined;
                        });
                        state.worker = undefined;
                        cleanUpAndTryToRestartWebWorker('Stats worker died 2', error);
                    });
                    const statWorker = createStatWorker(worker);
                    state.handlers.forEach(handler => {
                        handler.worker = statWorker;
                    });
                    state.worker = worker;
                    state.workerCreationIsInProgress = false;
                    resolve();
                }
            };
            worker.addEventListener('message', onReady);
            worker.addEventListener('error', onInitError);
        });
        let workerPromise;
        if (options.retryPromise) {
            workerPromise = options.retryPromise(createWorkerPromise, {
                maxTries: 5,
                retryTimeout: 3000,
                increaseTimeoutFactor: 1,
                maxRetryTimeout: 5000,
                logErrorsToConsole: true,
                waitUntilOnline: true,
            });
        }
        else {
            workerPromise = createWorkerPromise();
        }
        workerPromise.catch((error) => {
            cleanUpAndTryToRestartWebWorker(error.message, error);
        });
    }
}
function createStatWorker(worker) {
    return {
        postMessage: (data) => {
            switch (data.event) {
                case 'track':
                    {
                        const bufferData = data.payload.properties?.__bufferData;
                        if (bufferData && bufferData.transferables) {
                            worker.postMessage(data, bufferData.transferables);
                        }
                        else {
                            worker.postMessage(data);
                        }
                    }
                    break;
                case 'trackBatch':
                    {
                        let transferables = [];
                        data.payload.tracks.forEach(track => {
                            const bufferData = track.properties?.__bufferData;
                            if (bufferData && bufferData.transferables) {
                                transferables = transferables.concat(bufferData.transferables);
                            }
                        });
                        worker.postMessage(data, transferables);
                    }
                    break;
                default:
                    {
                        worker.postMessage(data);
                    }
                    break;
            }
        },
    };
}
function getMessageFromWorkerError(error) {
    let message;
    try {
        message = `Message: ${error.message}. Filename: ${error.filename}. Colno: ${error.colno}. RowNo: ${error.lineno}. Error: ${String(error.error)}`;
    }
    catch (e) {
        message = `Failed to create message`;
    }
    return message;
}
function getStoredUserIds() {
    const cookie = document.cookie;
    const anonymousId = (0, WebStatUtils_1.getStoredAnonymousId)();
    let userId = (0, WebStatUtils_1.getCookieFrom)(USER_ID_COOKIE_NAME, cookie);
    let workspaceId;
    if (userId) {
        const userInfos = userId.replace(/"/g, '').split('@');
        userId = userInfos[0];
        workspaceId = userInfos[1] || undefined;
    }
    else {
        userId = undefined;
    }
    if (userId === 'null') {
        userId = undefined;
    }
    if (userId === 'undefined') {
        userId = undefined;
    }
    return { userId, anonymousId, workspaceId };
}
function storeUserIds(userIds) {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    (0, WebStatUtils_1.setCookie)(ANONYMOUS_ID_COOKIE_NAME, `"${userIds.anonymousId}"`, {
        expires: date,
        path: '/',
    });
    if (userIds.userId) {
        (0, WebStatUtils_1.setCookie)(USER_ID_COOKIE_NAME, `"${userIds.userId}"`, {
            expires: date,
            path: '/',
        });
    }
    else {
        (0, WebStatUtils_1.deleteCookie)(USER_ID_COOKIE_NAME, {
            path: '/',
        });
    }
}
function getStatContextPage() {
    return {
        referrer: document.referrer,
        path: location.pathname,
        title: document.title,
        url: location.href,
        search: location.search,
        language: document.getElementsByTagName('html')[0].getAttribute('lang') || 'en',
        inIframe: inIframe(),
    };
}
function inIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
function getUserAgent() {
    return navigator.userAgent;
}
function getSessionId() {
    return (0, WebStatUtils_1.getOrGenerateSessionId)();
}
//# sourceMappingURL=WebStat.js.map